import { apiConstantsURL } from '../../constants/apiConstants';
import { axiosClient } from '../../utils/axiosClient';

export const loginUser = async (datapayload) => {
  const response = await axiosClient.post(
    apiConstantsURL.account.loginAccount,
    datapayload
  );
  return response;
};

export const registerUser = async (datapayload) => {
  const response = await axiosClient.post(
    apiConstantsURL.account.registerAccount,
    datapayload
  );
  return response;
};

export const verifyOTP = async (emailId, otp) => {
  const response = await axiosClient.post(
    apiConstantsURL.account.verifyOtp,
    { otp, emailId }
  );
  return response;
};

export const resetPasswordById = async (userId, datapayload) => {
  const response = await axiosClient.post(
    apiConstantsURL.account.resetPasswordById + userId,
    datapayload
  );
  return response;
};
export const resetPassword = async (datapayload) => {
  const response = await axiosClient.post(
    apiConstantsURL.account.resetPassword,
    datapayload
  );
  return response;
};

export const resendOTP = async (emailId) => {
  const response = await axiosClient.post(
    apiConstantsURL.account.resendOtp,
    { emailId }
  );
  return response;
};

export const saveNotificationSetting = async (datapayload) => {
  const response = await axiosClient.post(
    apiConstantsURL.account.saveSetting,
    datapayload
  );
  return response;
};

export const getNotificationSettings = async () => {
  const response = await axiosClient.get(apiConstantsURL.account.getSetting);
  return response;
};
